import { render, staticRenderFns } from "./Bookmark.vue?vue&type=template&id=6bb9793a&scoped=true&lang=pug&"
import script from "./Bookmark.vue?vue&type=script&lang=ts&"
export * from "./Bookmark.vue?vue&type=script&lang=ts&"
import style0 from "./Bookmark.vue?vue&type=style&index=0&id=6bb9793a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb9793a",
  null
  
)

export default component.exports